/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  JpClassSignupRef,
  JpClassSignupRefOptional,
  JpClassSignupRefMetaI,
  JpClassSignupRefTrackedI,
} from "./jp-class-signup-ref";
import {
  JpClassSignupRefTracked,
  JpClassSignupRefMeta,
} from "./jp-class-signup-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassWlResultRef,
  UnifiedClassWlResultRefOptional,
  UnifiedClassWlResultRefMetaI,
  UnifiedClassWlResultRefTrackedI,
} from "./unified-class-wl-result-ref";
import {
  UnifiedClassWlResultRefTracked,
  UnifiedClassWlResultRefMeta,
} from "./unified-class-wl-result-ref";

/**
 *
 * @export
 * @interface JpClassWlResultRef
 */
export interface JpClassWlResultRefOptional extends UnifiedClassWlResultRefOptional {
  /**
   *
   * @type {JpClassSignupRef}
   * @memberof JpClassWlResultRef
   */
  assignId?: JpClassSignupRefOptional;
}

export interface JpClassWlResultRef
  extends JpClassWlResultRefOptional, UnifiedClassWlResultRef {
  /**
   *
   * @type {JpClassSignupRef}
   * @memberof JpClassWlResultRef
   */
  assignId: JpClassSignupRef;
}

export interface JpClassWlResultRefTrackedI extends UnifiedClassWlResultRefOptional {
  /**
   *
   * @type {JpClassSignupRef}
   * @memberof JpClassWlResultRef
   */
  assignId?: JpClassSignupRefTrackedI;
  assignIdIsSet: boolean;
}

transformDatesMap.set(
  "JpClassWlResultRef",
  function (model: JpClassWlResultRef) {
    const transformDatesassignId = transformDatesMap.get("JpClassSignupRef");
    if (transformDatesassignId && model.assignId) {
      transformDatesassignId(model.assignId);
    }
  },
);

export type JpClassWlResultRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<JpClassSignupRefMetaI>;
}>;

export var JpClassWlResultRefMeta: JpClassWlResultRefMetaI =
  {} as JpClassWlResultRefMetaI;
JpClassWlResultRefMeta = typeMeta("JpClassWlResultRef", {
  assignId: propertyMeta("assignId", false, true, true, JpClassSignupRefMeta),
});

const metaI = JpClassWlResultRefMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassWlResultRefMeta]);
  metaI.assignId.inheritedFrom = UnifiedClassWlResultRefMeta.assignId;
});

export class JpClassWlResultRefTracked
  extends UnifiedClassWlResultRefTracked
  implements JpClassWlResultRefTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: JpClassSignupRefTracked = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | JpClassSignupRefTracked) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  constructor(config?: JpClassWlResultRefOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
    this.assignId?.setIds();
  }
  assignFrom(
    config: JpClassWlResultRefOptional,
    options?: AssignOptions,
  ): JpClassWlResultRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = new JpClassSignupRefTracked(config.assignId, options);
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): JpClassWlResultRefTrackedI {
    const cloned = {} as JpClassWlResultRefTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId?.removeUnset(filter);
    } else {
      //cloned.assignIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): JpClassWlResultRefTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;
    this.assignId?.unassignAll(filter);

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      JpClassWlResultRefMeta.assignId,
      JpClassWlResultRefMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;
    return this.assignId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
